// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"form_avatarImg_uOL7c","clearButtonContainer":"form_clearButtonContainer_2M90x"};